module.exports = [{"vendor":"firefox","version":"> 56"},{"vendor":"chrome","version":"= 62"},{"vendor":"iexplore","version":"> 9"},{"vendor":"safari","version":"> 25"},{"vendor":"netscape","version":"> 42.6"},{"vendor":"opera","version":"< 15.6"},{"vendor":"maxthon","version":">= 10"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/browsers.json
// module id = 603
// module chunks = 0